import { API } from './config/api';
import { VAPID_PUBLIC_KEY } from './config/config';

const urlBase64ToUint8Array = (base64String: string, scope: WindowOrWorkerGlobalScope = window) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

  const rawData = scope.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

export const isNotificationPermissionGranted = () => 'Notification' in window && Notification.permission === 'granted';
export const isServiceWorkerRegistered = () => 'serviceWorker' in navigator && 'PushManager' in window;
export const isAlreadySubscribed = async (existingRegistration?: ServiceWorkerRegistration) => {
  if (isServiceWorkerRegistered()) {
    let registration = existingRegistration;

    if (!registration) {
      registration = await navigator.serviceWorker.getRegistration();
    }

    if (!registration) {
      return;
    }

    const subscribed = await registration.pushManager.getSubscription();

    if (subscribed) {
      return true;
    }
  }

  return false;
};

const subscribeToPushEvents = async () => {
  if (isNotificationPermissionGranted()) {
    if (isServiceWorkerRegistered()) {
      const registration = await navigator.serviceWorker.getRegistration();
      if (!registration) {
        return;
      }

      const subscribed = await isAlreadySubscribed(registration);
      if (subscribed) {
        return;
      }

      if (VAPID_PUBLIC_KEY) {
        const subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
        });

        await API.subscriptions.saveSubscription(subscription);
      }
    }
  }
};

export const notificationService = {
  requestNotificationPermission: async () => {
    if (!isNotificationPermissionGranted()) {
      const permissionResult = await Notification.requestPermission();

      if (permissionResult !== 'granted') {
        return;
      }
    }

    await subscribeToPushEvents();
  },

  subscribeToPushEvents,
};
